import Vue from "vue";
import * as $ from "jquery";
import Component from "vue-class-component";
import { KeyValue } from "../../../../../shared/models/Input";
import { Prop } from "vue-property-decorator";
import { UtilisateurDto } from "../../../../../dto/GenApi.iNotPaie.Dto/UtilisateurDto";
import { ValideurCongesDto } from "../../../../../dto/GenApi.iNotPaie.Dto/ValideurCongesDto";
import { ServicesFactoryInstance } from "../../../../Controls/ServicesFactory";
import { NotificationServiceInstance } from "../../../../../shared/services/notification.service";
import { NiveauValidationEnum } from "../../../../../dto/GenApi.iNotPaie.Dto/NiveauValidationEnum";
import { ParametresInstance } from "../../../../Controls/Parameters";
import { AffichagePlanningUtilisateurEnum } from "../../../../../dto/GenApi.iNotPaie.Dto/AffichagePlanningUtilisateurEnum";

@Component
export default class ModalValidation extends Vue {

	@Prop()
	public listeUtilisateurs: UtilisateurDto[] = [];

	public listValidation: KeyValue[] = [
		{
			key: NiveauValidationEnum.Niveau_1.toString(),
			value: "Niveau 1"
		},
		{
			key: NiveauValidationEnum.Niveau_2.toString(),
			value: "Niveau 2"
		}
	];

	public valideurConges: ValideurCongesDto = {
		Id: 0,
		IdSalarie: 0,
		Utilisateur: {
			Id: 0,
			Origine: 0,
			AffichagePlanningEnum: AffichagePlanningUtilisateurEnum.Aucun,
			EstAffichagePlanningAnonymise: true
		},
		Niveau: 0,
		EnvoiEmail: false
	}

	public currentIdUtilisateur = "0";
	public currentIdNiveau = "0";
	public titleModal = "";
	public isNew = false;
	public dataReady = true;

	// ------------------------------------------------------------

	public init(validation: ValideurCongesDto): void {
		if(validation.Id !== 0) {
			this.titleModal = "Modification"
			this.isNew = false;
		} else {
			this.titleModal = "Création"
			this.isNew = true;
		}

		this.valideurConges = validation;
		this.currentIdUtilisateur = this.valideurConges.Utilisateur.Id.toString();
		this.currentIdNiveau = this.valideurConges.Niveau.toString();
	}

	public submit(): void {
		this.dataReady = false;

		this.valideurConges.Utilisateur.Id = Number(this.currentIdUtilisateur);
		this.valideurConges.Niveau = Number(this.currentIdNiveau);

		ServicesFactoryInstance.StatuAbsenceService.enregistrerValideurConges(this.valideurConges, (data) => {
			this.$emit("refreshListeValideursConges");
			NotificationServiceInstance.SendSuccess("Le valideur d'absences a bien été sauvegardé");
			$("#modalValidation").modal("hide");
			this.dataReady = true;
		}, () => { this.dataReady = true; });
	}

	public cancel(): void {
		$("#modalValidation").modal("hide");
	}

	public transformList(list: UtilisateurDto[]): KeyValue[] {
		const finalList: KeyValue[] = [];

		for (let i = 0; i < list.length; i++) {
			finalList.push({
				key: list[i].Id.toString(),
				value: `${list[i].Nom} ${list[i].Prenom} (${ParametresInstance.getLibelleOrigineUtilisateur(list[i].Origine)})`
			});
		}

		return finalList;
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/absences/validationAbsence/modalValidation/modalValidation.ts